import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const form: SxStyle = {
  display: 'none !important',
};
